import BaseApp from "../BaseApp";
import {isString} from "../../funcs";

export default class DynamicJournalBgApp extends BaseApp {

    onReady() {
        const menuChannel = system.apps.channel("Menu");
        const userJournalsIds = system.user.model.get("DYNAMIC_JOURNALS_IDS") || [];
        if ( !userJournalsIds.length ) {
            return;
        }
        let userJournalsJson = system.user.model.get("DYNAMIC_JOURNALS_JSON");
        try {
            if ( isString(userJournalsJson) ) {
                userJournalsJson = JSON.parse(userJournalsJson);
            }
        } catch (err) {
            err;
        }

        for (let journalId in userJournalsJson) {
            const journalConfig = userJournalsJson[ journalId ];
            const appId = "DYNAMIC_JOURNALS." + journalId;

            system.setRunConfig(appId, {
                type: "Form2",
                form2: "DynamicJournalForm",
                data: {
                    DYNAMIC_JOURNALS_ID: journalId,
                    NAME: journalConfig.name,
                    ENTITY_NAME: journalConfig.entity
                }
            });

            menuChannel.addItem({
                item: {
                    app: appId,
                    title: journalConfig.name
                },
                into: { icon: "pie-chart" }
            });
        }
    }
}